/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { ReactNode } from 'react';

// Declaring prop types for DataTableBodyCell
interface Props {
  children: ReactNode;
  noBorder?: boolean;
  align?: 'left' | 'right' | 'center';
}

const alignClass = {
  left: 'text-left',
  right: 'text-right',
  center: 'text-center',
} as const;

function DataTableBodyCell({
  noBorder = false,
  align = 'left',
  children,
  ...rest
}: Props & Record<string, unknown>) {
  return (
    <td
      className={[
        'py-3 px-3 text-sm align-middle',
        alignClass[align],
        noBorder ? '' : 'border-b border-stone-200',
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      <span className="inline-block max-w-full align-middle text-stone-800">
        {children}
      </span>
    </td>
  );
}

export default DataTableBodyCell;
